"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = Loader;
var jsx_runtime_1 = require("react/jsx-runtime");
var RING_CLASSES = {
    sm: { box: "w-8 h-8", border: "border-2" },
    md: { box: "w-12 h-12", border: "border-3" },
    lg: { box: "w-16 h-16", border: "border-4" },
};
function Ring(props) {
    var size = props.size, label = props.label;
    var _a = RING_CLASSES[size], box = _a.box, border = _a.border;
    return ((0, jsx_runtime_1.jsxs)("div", { role: "status", "aria-label": label !== null && label !== void 0 ? label : "Loading", className: "flex flex-col items-center gap-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "relative ".concat(box), children: [(0, jsx_runtime_1.jsx)("div", { className: "absolute inset-0 rounded-full border-primary-navy/10 ".concat(border) }), (0, jsx_runtime_1.jsx)("div", { className: "absolute inset-0 rounded-full border-transparent border-t-primary-green animate-spin ".concat(border) })] }), label && (0, jsx_runtime_1.jsx)("p", { className: "text-sm text-medium-gray animate-pulse", children: label })] }));
}
function Loader(props) {
    var _a = props.variant, variant = _a === void 0 ? "page" : _a, size = props.size, label = props.label;
    if (variant === "inline") {
        return (0, jsx_runtime_1.jsx)(Ring, { size: size !== null && size !== void 0 ? size : "sm", label: label });
    }
    if (variant === "overlay") {
        return ((0, jsx_runtime_1.jsx)("div", { className: "absolute inset-0 z-50 flex items-center justify-center rounded-[inherit] bg-white/70 backdrop-blur-[2px]", children: (0, jsx_runtime_1.jsx)(Ring, { size: size !== null && size !== void 0 ? size : "md", label: label }) }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-1 items-center justify-center min-h-96 h-full w-full", children: (0, jsx_runtime_1.jsx)(Ring, { size: size !== null && size !== void 0 ? size : "lg", label: label }) }));
}
